"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserUnauthorizedIPLogs_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var UserUnauthorizedIPLogs_Factory = /** @class */ (function () {
    function UserUnauthorizedIPLogs_Factory() {
    }
    UserUnauthorizedIPLogs_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AttemptTimeStamp: Date_Factory_1.Date_Factory.CreateIncoming(model.AttemptTimeStamp),
            IPAddress: model.IPAddress,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            UserId: model.UserId,
            Users: User_1.User_Factory.CreateIncoming(model.Users),
        };
        return result;
    };
    UserUnauthorizedIPLogs_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AttemptTimeStamp: Date_Factory_1.Date_Factory.CreateOutgoing(model.AttemptTimeStamp),
            IPAddress: model.IPAddress,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            UserId: model.UserId,
            Users: User_1.User_Factory.CreateOutgoing(model.Users),
        };
        return result;
    };
    return UserUnauthorizedIPLogs_Factory;
}());
exports.UserUnauthorizedIPLogs_Factory = UserUnauthorizedIPLogs_Factory;
